// eslint-disable-next-line import/no-unresolved
import { produce } from 'immer';

export default {
  1: state => {
    const newState = produce(state, draft => {
      draft.addressAutocomplete = {};

      if (state.addressAutocompleteData) {
        draft.addressAutocomplete = state.addressAutocompleteData;
        delete draft.addressAutocompleteData;
      }
    });

    return newState;
  },
};
